import { Link } from "react-router-dom";
import PhoenixImage from "./PhoenixImage";
import { Mail, Phone, Globe } from "lucide-react";

const Footer = () => (
  <footer className="mt-20 border-t border-teal-500/15 bg-[#0a1418]/60" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="grid md:grid-cols-2 gap-10 items-start">
        <div>
          <Link to="/" className="flex items-center gap-3 group">
            <PhoenixImage variant="mark" size={48} className="group-hover:opacity-80 transition-opacity" />
            <div>
              <div className="font-display text-xl text-neutral-100">Why We Recover</div>
              <div className="text-[10px] tracking-[0.28em] text-teal-300/80 uppercase mt-0.5">
                Inspiring strength · Empowering recovery
              </div>
            </div>
          </Link>
        </div>

        <div className="flex flex-col gap-3 text-sm text-neutral-300 md:items-end">
          <a
            href="mailto:community@whywerecovercollective.org"
            data-testid="footer-email"
            className="inline-flex items-center gap-2 hover:text-teal-200"
          >
            <Mail size={14} className="text-teal-300" />
            community@whywerecovercollective.org
          </a>
          <a
            href="tel:+13604091672"
            data-testid="footer-phone"
            className="inline-flex items-center gap-2 hover:text-teal-200"
          >
            <Phone size={14} className="text-teal-300" />
            360-409-1672
          </a>
          <span data-testid="footer-site" className="inline-flex items-center gap-2 text-neutral-400">
            <Globe size={14} className="text-teal-300" />
            whywerecover.net
          </span>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-teal-500/10 flex flex-wrap justify-between gap-3 text-xs text-neutral-500">
        <span>© {new Date().getFullYear()} Why We Recover Collective</span>
        <span>This site offers self-reflection tools — not medical advice or diagnosis.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
